import installationInstructions from './installationInstructions';

const knokContent = {
  installationInstructions
}

export { knokContent };